import InstagramPng from "../../../../assets/customerAssets/icons/instagram.png";

function InstagramWebShare({ url }) {
  const handleShare = async () => {
    await navigator.clipboard.writeText(url);
    alert("Link copied! Paste it in Instagram to share.");
    window.open("https://www.instagram.com/", "_blank");
  };

  return (
    <button
      onClick={handleShare}
      className="insta-inline-btn"
      title="Share on Instagram"
    >
      <img src={InstagramPng} alt="Instagram" />
    </button>
  );
}

export default InstagramWebShare;
